import React, { useEffect, useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import EntityModelManager from '../components/EntityModelManager';
import { getOrganizations } from '../services/api';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const EntityModelManagerPage = ({ user, onLogout }) => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const orgsData = await getOrganizations();
        setOrganizations(orgsData?.results || []);
      } catch (error) {
        console.error('Error loading organizations:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  if (loading) {
    return (
      <DashboardLayout user={user} onLogout={onLogout}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 200,
          }}
        >
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading entity models...</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <EntityModelManager organizations={organizations} user={user} />
      </Box>
    </DashboardLayout>
  );
};

export default EntityModelManagerPage;
